import { parseISO } from 'date-fns';
import { useMemo, VFC } from 'react';

import {
  MintBidWithCreation,
  useCurrentUserMintBids,
} from '@/apis/aniftyBackend/mintBids/getCurrentUserMintBids';
import DefaultSpinner from '@/components/DefaultSpinner';
import FailedAndRetry from '@/components/FailedAndRetry';
import styles from '@/containers/AuctionActivity/AuctionActivity.module.scss';
import AuctionActivityCard from '@/containers/AuctionActivity/AuctionActivityCard';
import NoItemsAnimon from '@/containers/UserProfilePage/NoItemsAnimon';

const MyBidsList: VFC = () => {
  const {
    data: ungroupedMintBids,
    isLoading,
    isLoadingError,
    refetch,
    isSuccess,
  } = useCurrentUserMintBids({});

  const mintBids = useMemo<MintBidWithCreation[]>(() => {
    if (!ungroupedMintBids) {
      return [];
    }

    const mintBidWithoutDuplicates: MintBidWithCreation[] = [];

    // Filter mint bids only with the latest bids
    ungroupedMintBids
      // Sort by new
      .sort((a, b) => parseISO(b.bidAt).getTime() - parseISO(a.bidAt).getTime())
      .forEach((mintBid) => {
        if (
          mintBidWithoutDuplicates.every(
            (_mintBid) => _mintBid.askHash !== mintBid.askHash
          )
        ) {
          mintBidWithoutDuplicates.push(mintBid);
        }
      });

    return mintBidWithoutDuplicates;
  }, [ungroupedMintBids]);

  return (
    <div className={styles.activityContent}>
      {isLoading ? (
        <div className={styles.message}>
          <DefaultSpinner />
        </div>
      ) : null}

      {isLoadingError ? (
        <FailedAndRetry isProcessing={isLoading} onRetryButtonClick={refetch} />
      ) : null}

      {isSuccess ? (
        <>
          {mintBids?.length ? (
            <div className={styles.listContainer}>
              {mintBids.map((mintBid) => (
                <AuctionActivityCard
                  key={mintBid.bidID}
                  mintBidWithCreation={mintBid}
                />
              ))}
            </div>
          ) : (
            <NoItemsAnimon />
          )}
        </>
      ) : null}
    </div>
  );
};

export default MyBidsList;
